import { render, staticRenderFns } from "./salesDistributionSearch.vue?vue&type=template&id=5b38ad52&scoped=true"
import script from "./salesDistributionSearch.vue?vue&type=script&lang=js"
export * from "./salesDistributionSearch.vue?vue&type=script&lang=js"
import style0 from "./salesDistributionSearch.vue?vue&type=style&index=0&id=5b38ad52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38ad52",
  null
  
)

export default component.exports